// extracted by mini-css-extract-plugin
export var active = "_lb-e";
export var blink = "_lb-f";
export var dropDownSelector = "_lb-5";
export var dropDownWrapper = "_lb-4";
export var fakeCursor = "_lb-d";
export var fontSizeButton = "_lb-7";
export var formQuillEditor = "_lb-0";
export var pressed = "_lb-g";
export var qlBlank = "_lb-1";
export var textFormattingToolbar = "_lb-2";
export var textFormattingToolbarClosed = "_lb-3";
export var textFormattingToolbarInline = "_lb-6";
export var textToolbarOption = "_lb-8";
export var toolbarCell = "_lb-a";
export var toolbarCellCollapsed = "_lb-b";
export var toolbarOptionHitArea = "_lb-c";
export var toolbarOverflow = "_lb-9";